import { FirebaseError, initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
} from "firebase/auth";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { getMessaging } from "firebase/messaging";
import { getStorage } from "firebase/storage";

// web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY as string,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN as string,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID as string,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET as string,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID as string,
  appId: process.env.REACT_APP_FIREBASE_APP_ID as string,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID as string,
  vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY as string,
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Export the config for debugging
export { firebaseConfig };

export const auth = getAuth(app);
export const db = getFirestore(app);

export const messaging = getMessaging(app);

export const storage = getStorage(app);

// Authentication functions

export const logInWithEmailAndPassword = async (
  email: string,
  password: string,
): Promise<{ success: boolean; error?: string }> => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    // Force token refresh to avoid old token issue
    await user.getIdToken(true);

    return { success: true }; // login successful
  } catch (err) {
    // console.error("Login Error:", err);

    // Handle specific Firebase Auth errors
    // let errorMessage = "An unknown error occurred"; // Default error message
    // let errorMessage = "invalid login credentials";
    let errorMessage = "INVALID_LOGIN_CREDENTIALS";

    if (err instanceof FirebaseError) {
      // Firebase specific error handling
      switch (err.code) {
        // case "auth/invalid-email":
        //   errorMessage = "Invalid email address.";
        //   break;
        // case "auth/user-disabled":
        //   errorMessage = "This user account has been disabled.";
        //   break;
        // case "auth/user-not-found":
        //   errorMessage = "No user found with this email.";
        //   break;
        // case "auth/wrong-password":
        //   errorMessage = "Incorrect password.";
        //   break;
        default:
          // errorMessage = err.message;
          break;
      }
    }

    return { success: false, error: errorMessage };
  }
};

/**
 * This function creates a new admin user.
 * @param name : user's name
 * @param email : user's email address
 * @param password : user's password
 */
export const registerWithEmailAndPassword = async (name: string, email: string, password: string) => {
  try {
    const res = await createUserWithEmailAndPassword(auth, email, password);
    const user = res.user;
    await addDoc(collection(db, "users"), {
      uid: user.uid,
      name,
      authProvider: "local",
      email,
    });
  } catch (err) {
    // console.error(err);
  }
};

/**
 * This function sends a reset password email for the given email of the user
 * @param email : user's email address
 * @returns Promise<boolean> : promise which is true if email is sent and false otherwise.
 */
export const sendPasswordReset = async (email: string): Promise<boolean> => {
  try {
    await sendPasswordResetEmail(auth, email);
    return true;
  } catch (err) {
    // console.error(err);
    return false;
  }
};

/**
 * This function logs the current user out of the web app
 */
export const logout = async (): Promise<void> => {
  try {
    await signOut(auth);
    localStorage.removeItem("entityId");
  } catch (error) {
    // console.error("Error logging out:", error);
  }
};
